<div class="mf-lay-menu d-flex flex-column h-100">
    <lay-men-header (onMenuSizeChange)="minMenu($event)"></lay-men-header>
    <div class="py-2"></div>
    <lay-men-menu [isMin]="isMin"></lay-men-menu>
    <lay-men-footer class="mt-auto pb-4"></lay-men-footer>
</div>
